import React, { forwardRef } from 'react';

interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
  success?: boolean;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ error, success, className = '', ...props }, ref) => {
    const baseClasses = `
      w-full px-2 py-1.5 border rounded-2xl font-medium text-slate-900 
      placeholder:text-slate-400 transition-all duration-200 resize-none
      focus:outline-none focus:ring-2 focus:ring-offset-0
      ${error ? 'pr-10' : success ? 'pr-10' : 'pr-2'}
    `;

    const stateClasses = error
      ? 'border-red-300 bg-red-50/50 focus:border-red-500 focus:ring-red-500/20 focus:bg-white'
      : success
        ? 'border-green-300 bg-green-50/50 focus:border-green-500 focus:ring-green-500/20 focus:bg-white'
        : 'border-slate-300 bg-slate-50/50 focus:border-blue-500 focus:ring-blue-500/20 focus:bg-white hover:border-slate-400';

    return (
      <textarea
        ref={ref}
        className={`${baseClasses} ${stateClasses} ${className}`}
        {...props}
      />
    );
  }
);

Textarea.displayName = 'Textarea';

export default Textarea;
